
export const calenderOrikomi = () => {
    $(function () {

        // ----------------------------------
        // カレンダークリック機能
        // ----------------------------------
        const eigyonichi = 3; // 営業日を初期化

		const specialHolidays = [
			{
				selectDay : "2024-01-01",
				submitDay : "2023-12-22"
			},
			{
				selectDay : "2024-01-02",
				submitDay : "2023-12-22"
			},
			{
				selectDay : "2024-01-03",
				submitDay : "2023-12-22"
			},
			{
				selectDay : "2024-01-04",
				submitDay : "2023-12-22"
			},
			{
				selectDay : "2024-01-05",
				submitDay : "2023-12-22"
			},
			{
				selectDay : "2024-01-06",
				submitDay : "2023-12-28"
			},
			{
				selectDay : "2024-01-07",
				submitDay : "2024-01-05"
			},
			{
				selectDay : "2024-01-08",
				submitDay : "2024-01-05"
			},
			{
				selectDay : "2024-01-09",
				submitDay : "2024-01-05"
			},
			{
				selectDay : "2024-01-10",
				submitDay : "2024-01-05"
			},
		]
        $(".calender .js-click-day").on('click', function () {
            // クラスを持っているとき、処理を終了する
            if ($(this).hasClass('kyukanbi')) {
                return;
            }
            // kibobiを外す
            $(".calender td").removeClass('kiboubi');
            // kibobiをつける
            $(this).addClass('kiboubi');

            // ----------------------------------
            // データ初期化
            // ----------------------------------
            var holidayCount = 0; // 休日の数をカウント

            var loopCount = 0;

            const clickDateEl = $(this).data('date'); // クリックした日

			
            // 再起関数を使って休日をはさむたびにチラシ納品期日を先延ばしにする
            function kizitsuCal() {
                loopCount++;

                var loopHolidayCount = 0; // そのループ内での休日の数をカウント

                if (loopCount == 1) {
                    for (var daySet = 1; daySet <= eigyonichi; daySet++) {
                        var date = new Date(clickDateEl);
                        date.setDate(date.getDate() - daySet); // 〇日前に日付のデータをセット
                        var year = date.getFullYear();
                        var month = date.getMonth() + 1;
                        var day = date.getDate(); // 現在の日付取得

                        // 営業日前のテーブルデータを取得
                        if ($('td[data-date="' + year + '-' + month.toString().padStart(2, "0") + '-' + day.toString().padStart(2, "0") + '"]').data('isHoliday') == 1) {
                            holidayCount++;
                            loopHolidayCount++;
                        }
                    }
                } else {
                    for (var daySet = eigyonichi + loopCount - 1; daySet < eigyonichi + loopCount; daySet++) {
                        var date = new Date(clickDateEl);
                        date.setDate(date.getDate() - daySet); // 〇日前に日付のデータをセット
                        var year = date.getFullYear();
                        var month = date.getMonth() + 1;
                        var day = date.getDate(); // 現在の日付取得

                        // 営業日前のテーブルデータを取得
                        if ($('td[data-date="' + year + '-' + month.toString().padStart(2, "0") + '-' + day.toString().padStart(2, "0") + '"]').data('isHoliday') == 1) {
                            holidayCount++;
                            loopHolidayCount++
                        }
                    }
                }
                if (loopHolidayCount != 0) {
                    kizitsuCal();
                }

                return;
            }


            // 挟んだ休日の数
            kizitsuCal();


            const addClassDate = new Date(clickDateEl);
            addClassDate.setDate(addClassDate.getDate() - eigyonichi - holidayCount); // 〇日後に日付のデータをセット

            var year = addClassDate.getFullYear();
            var month = addClassDate.getMonth() + 1;
            var day = addClassDate.getDate(); // 現在の日付取得
            // すべてのkizitsuクラスを外す
            $(".calender td").removeClass('kizitsu');
			
            if ($('td[data-date="' + year + '-' + month.toString().padStart(2, "0") + '-' + day.toString().padStart(2, "0") + '"]').data('isHoliday') !== 1) {
				let specialHolidaySettingFlg = false; // 特殊な休日が挟まれた場合のフラグ
				specialHolidays.forEach(specialHoliday => {
					// 特殊な休日を挟む場合はあらかじめ指定されてる日に納品日を設定
					const specialDate = new Date(specialHoliday.selectDay);
					const specialYear = specialDate.getFullYear();
					const specialMonth = specialDate.getMonth() + 1;
					const specialDay = specialDate.getDate(); // 現在の日付取得
					const currentDate = new Date(clickDateEl);
					const currentYear = currentDate.getFullYear();
					const currentMonth = currentDate.getMonth() + 1;
					const currentDay = currentDate.getDate(); // 現在の日付取得

					if(currentYear === specialYear &&
						currentMonth === specialMonth &&
						currentDay === specialDay) {
							const addClassDate = new Date(specialHoliday.submitDay);
							const settingYear = addClassDate.getFullYear();
							const settingMonth = addClassDate.getMonth() + 1;
							const settingDay = addClassDate.getDate(); // 現在の日付取得
							$('td[data-date="' + settingYear + '-' + settingMonth.toString().padStart(2, "0") + '-' + settingDay.toString().padStart(2, "0") + '"]').addClass('kizitsu');
							specialHolidaySettingFlg = true;	
					}
				});
				if (!specialHolidaySettingFlg) {
					$('td[data-date="' + year + '-' + month.toString().padStart(2, "0") + '-' + day.toString().padStart(2, "0") + '"]').addClass('kizitsu');
				}
            } else {

                for (var daySet = 1; daySet <= 30; daySet++) {

                    addClassDate.setDate(addClassDate.getDate() - 1); // 〇日後に日付のデータをセット
                    var year = addClassDate.getFullYear();
                    var month = addClassDate.getMonth() + 1;
                    var day = addClassDate.getDate(); // 現在の日付取得


                    if ($('td[data-date="' + year + '-' + month.toString().padStart(2, "0") + '-' + day.toString().padStart(2, "0") + '"]').data('isHoliday') !== 1) {
                        $('td[data-date="' + year + '-' + month.toString().padStart(2, "0") + '-' + day.toString().padStart(2, "0") + '"]').addClass('kizitsu');
                        break;
                    }


                }


            }

        });
    });

};